import {apiGetBuysByFactor} from "api/reportApi";

import {AmountComponent, CheckComponent, PriceComponent} from "components/Table/CellComponents";
import {openFactorDrawer} from "../helpers/DrawerActions";

const BuysByFactorColumns = [
    {
        name: "برگشتی",
        key: "reference",
        // @ts-ignore
        getValue: (item) => {
            return item.reference || "-";
        },
        Component: CheckComponent,
        size: "2",
        disableSearch: true,
        filterParams: {
            column: "reference",
            columnType: "string",
        },
    },
    {
        name: "تاریخ",
        key: "date",
        size: "3",
        showDatePicker: true,
        searchType: "date",
        filterParams: {
            column: "date",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "کد حسابداری",
        key: "accountingCode",
        size: "2",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "شرح",
        key: "description",
        size: "2",
        onClick: (dispatch: any, item: any) => {
            item.type_id = item.factorId;
            openFactorDrawer(dispatch, item);
        },
        filterParams: {
            column: "description",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "شخص",
        key: "person",
        size: "3",
        navigateKey: (item: any) => item.personId,
        navigate: "/reports/personalAccountCard?personId=",
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
        filterParams: {
            column: "person",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "تعداد",
        key: "quantity",
        size: "2",
        Component: AmountComponent,
        searchType: "quantitative",
        filterParams: {
            column: "quantity",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ واحد",
        key: "priceUnit",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "priceUnit",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ مجموع کالا",
        key: "price",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "price",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "تخفیف",
        key: "discount",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "discount",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مالیات",
        key: "tax",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "tax",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "کل مبلغ",
        key: "totalPrice",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "totalPrice",
            columnType: "number",
        },
        // disableSearch: true,
    },
];

export const BuysByFactorIndexData = [
    {
        key: "buyByFactor",
        label: "خرید به تفکیک فاکتور",
        pluralLabel: "خرید به تفکیک فاکتور",
        title: "خرید به تفکیک فاکتور",
        pageTitle: "خرید به تفکیک فاکتور",
        // pageDescription: "نمایش اطلاعات خرید به تفکیک فاکتور",
        tableColumns: BuysByFactorColumns,
        disableSearch: true,
        actions: {
            back: {},
            fetch: apiGetBuysByFactor,
            // excel: {},
        },
    },
];
